/**
 * <title> strings for static, non-dynamic content routes — a single source
 * shared by the build-time SSR head (entry-server.tsx's ROUTE_HEAD) and each
 * route's client-side `useDocumentTitle()` call, so the prerendered title and
 * the in-app tab title can never drift out of sync with each other.
 *
 * Dynamic routes (games, practice hubs/topics, test landings, quizzes) compute
 * their own title from data already in the component instead of living here —
 * see each route's `useDocumentTitle(...)` call site.
 */
export const SEO_TITLES: Record<string, string> = {
  // Deliberately does NOT compete with /games for "math games for kids" —
  // /games is the better-matched page for that query (it's the actual game
  // list) and should own it outright rather than splitting authority across
  // two pages. The homepage's job is brand + conversion.
  "/": "Sports Academy Games — Real Games, Real Math",
  "/about": "About — Sports Academy Games",
  "/privacy": "Privacy — Sports Academy Games",
  "/terms": "Terms of Use — Sports Academy Games",
  "/trust": "Trust & Safety — Sports Academy Games",
  "/features": "Features — Sports Academy Games",
  "/compare": "Math Games vs. Worksheets & Tutoring — Sports Academy Games",
  // Teacher funnel: "free math homework" phrasing is what searching teachers
  // type; the brand rides second.
  "/teachers": "Free Math Homework Games for Your Class — Sports Academy Games",
  "/games": "Math Games for Kids — Sports Academy Games",
  "/community": "Community Math Quizzes — Sports Academy Games",
  "/plans": "Plans & Pricing — Sports Academy Games",
  "/practice": "Free Math Practice by Grade (K–12) — Sports Academy Games",
  "/test-prep": "Standardized Test Math Prep (K–12) — Sports Academy Games",
  "/test-prep/all": "All Standardized Test Math Prep — By State & Exam",
  "/blog": "Blog — Sports Academy Games",
};
